import { React } from "react";
import img from "../images/pic.jpg";
import "../styles/home.css";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function Home({ theme }) {
  return (
    <motion.div
      className="home"
      style={{
        backgroundColor: theme === "white" ? "white" : "black",
        color: theme === "white" ? "gray" : "gray",
      }}
      variants={{
        hidden: { opacity: 0, y: 0 },
        visible: { opacity: 1, y: 0 },
      }}
      initial="hidden"
      animate="visible"
    >
      <div className="upper__div">
        <div className="para">
          <div className="text">
            <span className="main__heading__top">JAI SHREE RAM</span>
            <br />
            <div>
              {" "}
              I'm <strong className="name">Kamlesh Joshi</strong>
              <br />
              <p>
                Software Developer (MERN)
                <br />& Competitive Prgrammer{" "}
              </p>
            </div>
          </div>
        </div>
        <div className="img">
          <img src={img} alt="" className="img-main" id="img" />
          <p className="resume">
            <a
              href="https://bit.ly/kamlesh-joshi-resume"
              rel="noreferrer"
              target="_blank"
            >
              View Resume
            </a>
          </p>
        </div>
        <div className="bottom">
          <div className="about">
            <svg
              fill="currentColor"
              height="1em"
              stroke="currentColor"
              strokeWidth="0"
              viewBox="0 0 1024 1024"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 0 0 0 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"></path>
            </svg>
            <Link to="/about" className="abt-text">
              About me
            </Link>
          </div>
          <div className="projects">
            <Link to="/projects" className="abt-text">
              Projects
            </Link>
            <svg
              fill="currentColor"
              height="1em"
              stroke="currentColor"
              strokeWidth="0"
              viewBox="0 0 1024 1024"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 0 0 0-48.4z"></path>
            </svg>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default Home;
